import React from 'react';
import FeaturedCategories from '../pages/FeaturedCategories';
import FeatureSection from '../pages/FeatureSection';
import PopularCars from '../pages/PopularCars';
import BrandSection from '../pages/BrandSection';
import RentalSteps from '../pages/RentalSteps';
import PopularRecommendation from '../pages/PopularRecommendation';
import TestimonialSection from '../pages/TestimonialSection';
import BlogSection from '../pages/BlogSection';
import FaqSection from '../pages/FaqSection';
import ServicesSectionn from '../pages/ServicesSectionn';
import PopularCarss from '../pages/PopularCarss';
import PopularCarTypes from '../pages/PopularCarTypes';
import FactsNumber from '../pages/FactsNumber';
import PopularServices from '../pages/PopularServices';
import WhyChooseSection from '../pages/WhyChooseSection';
import Testimonials from '../pages/Testimonials';
import UserAppSection from '../pages/UserAppSection';
import BlogSectionn from '../pages/BlogSectionn';
import Carousel from './Carousel';




const HeroSection = () => {
  
  return (

    <div className="th-hero-wrapper hero-1" id="hero">
<Carousel/>
 <ServicesSectionn/>
 <PopularCarss/>
 <FactsNumber/>
 <PopularServices/>
 <WhyChooseSection/>
 <Testimonials/>
 <UserAppSection/>
 <BlogSectionn/>
 {/* <PopularCarTypes/> */}
 {/* <RentalSectionFour/> */}
{/* <FeaturedCategories/> */}
{/* <FeatureSection/> */}
{/* <PopularCars/> */}
{/* <BrandSection/> */}
{/* <RentalSteps/> */}
{/* <PopularRecommendation/> */}
{/* <TestimonialSection/>
<BlogSection/>
<FaqSection/> */}
    </div>
  );
};

export default HeroSection;
